import React, { Component } from 'react';

import '../assets/fonts/wingdings2.ttf';
import '../assets/fonts/aero_matics_display_regular.ttf';
import '../css/iteam.css';
import '../css/numpad.css';
import '../css/unitsmenu.css';
import '../css/booksmenu.css';
import '../css/colorsmenu.css';
import '../css/mainmenu.css';

import { getXmlFile } from '../common/xmlretriever';
import { parseXMLtoJS } from '../common/parseXMLtoJS';

import { prepareMainMenuDataModel } from '../datamodel/prepareDataModel';
import { iteamMenuModelInstance } from '../datamodel/datamodel';

import IteamHeaderContainer from './IteamHeaderContainer';
import IteamFooterContainer from './IteamFooterContainer';
import IteamMiddleContainer from './IteamMiddleContainer';
import IteamFooterPageNavBar from './IteamFooterPageNavBar';
import IteamFooterExerciseNavBar from './IteamFooterExerciseNavBar';
import IteamMainMenu from './IteamMainMenu';


var mainMenuXmlFile = 'data/mainmenu.xml';
//var mainMenuXmlFile = '../../../data/mainmenu.xml';

class IteamContainer extends Component {
    constructor() {
        super();
        this.state = { isExerciseModeActive: false,
                       activeLayer: 'mainmenu',
                       mainMenuDM: null,
                       units: [],
                       enableGameInputs: true,
                       headerinfo: {sectiontitle: '', chaptertitle: '', pagenumbers: '', type: ''},
                       exerciseAudioDM: null,
                       exerciseVideoDM: null,
                       pageAudioDM: null,
                       pageVideoDM: null,
                       enablePageNavigation: true
                    };

        this.setIsExerciseModeActive = this.setIsExerciseModeActive.bind(this);
        this.loadSectionHandler = this.loadSectionHandler.bind(this);
        this.loadMainMenuHandler = this.loadMainMenuHandler.bind(this);
        this.httpXmlResponseSuccess = this.httpXmlResponseSuccess.bind(this);
        this.httpXmlResponseFailure = this.httpXmlResponseFailure.bind(this);
        this.setUnitsCallBack = this.setUnitsCallBack.bind(this);
        this.navigateToChapterIndex = this.navigateToChapterIndex.bind(this);
        this.gotoPageNumber = this.gotoPageNumber.bind(this);
        this.disableGameInputsCallback = this.disableGameInputsCallback.bind(this);
        this.enableGameInputsCallback = this.enableGameInputsCallback.bind(this);
        this.setHeaderTitleInfoCallback = this.setHeaderTitleInfoCallback.bind(this);

        this.setExerciseCloseCallback = this.setExerciseCloseCallback.bind(this);
        this.setExerciseAudioDMHandler = this.setExerciseAudioDMHandler.bind(this);
        this.setExerciseVideoDMHandler = this.setExerciseVideoDMHandler.bind(this);

        this.setPagePauseAudioCallback = this.setPagePauseAudioCallback.bind(this);
        this.setPagePauseVideoCallback = this.setPagePauseVideoCallback.bind(this);
        this.setPageAudioDMHandler = this.setPageAudioDMHandler.bind(this);
        this.setPageVideoDMHandler = this.setPageVideoDMHandler.bind(this);

        this.closeExerciseCallBack = null;
        this.pausePageAudioCallBack = null;
        this.pausePageVideoCallBack = null;

        this.iteamMiddleContainer = React.createRef();

    }

    componentDidMount() {
        getXmlFile(mainMenuXmlFile, this.httpXmlResponseSuccess, this.httpXmlResponseFailure);
    }

    httpXmlResponseSuccess(response) {
        let mainMenuJS = parseXMLtoJS(response.data);
        let mainMenuDM = prepareMainMenuDataModel(mainMenuJS);
        iteamMenuModelInstance.setIteamMenuModelInstance(mainMenuDM);
        this.setState({ mainMenuDM: mainMenuDM });
    }

    httpXmlResponseFailure(error) {
        console.log(error);
    }

    setIsExerciseModeActive(value) {
        this.setState({ isExerciseModeActive: value });
    }

    loadSectionHandler(sectionItem) {
        this.iteamMiddleContainer.loadBookContent(sectionItem);
        this.setState({mainMenuSection: sectionItem});
        this.setState({activeLayer: sectionItem.type});    
    }

    loadMainMenuHandler() {
        if (this.closeExerciseCallBack !== null) {
            this.closeExerciseCallBack();
        }
        if (this.pausePageAudioCallBack !== null) {
            this.pausePageAudioCallBack();
        }
        if (this.pausePageVideoCallBack !== null) {
            this.pausePageVideoCallBack();
        }
        this.setState({activeLayer: 'mainmenu'});
    }

    setUnitsCallBack(units) {
        this.setState({units: units});
    } 

    navigateToChapterIndex(index) {
        if (this.pausePageAudioCallBack !== undefined && this.pausePageAudioCallBack !== null) {
            this.pausePageAudioCallBack();
        }
        if (this.pausePageVideoCallBack !== undefined && this.pausePageVideoCallBack !== null) {
            this.pausePageVideoCallBack();
        }
        this.iteamMiddleContainer.iteamInteractionContainer.navigateToChapterIndex(index);
    }

    gotoPageNumber(number) {
        if (this.pausePageAudioCallBack !== undefined && this.pausePageAudioCallBack !== null) {
            this.pausePageAudioCallBack();
        }
        if (this.pausePageVideoCallBack !== undefined && this.pausePageVideoCallBack !== null) {
            this.pausePageVideoCallBack();
        }
        this.iteamMiddleContainer.iteamInteractionContainer.gotoPageNumber(number);
    }

    disableGameInputsCallback() {
        this.setState({enableGameInputs: false});
    }

    enableGameInputsCallback() {
        this.setState({enableGameInputs: true});
    }

    setHeaderTitleInfoCallback(headerinfo) {
        this.setState({headerinfo: headerinfo});
    }

    setExerciseAudioDMHandler(audioDM) {
        this.setState({exerciseAudioDM: audioDM});
    }

    setExerciseVideoDMHandler(videoDM) {
        this.setState({exerciseVideoDM: videoDM});
    }

    setPageAudioDMHandler(audioDM) {
        this.setState({pageAudioDM: audioDM});
    }

    setPageVideoDMHandler(videoDM) {
        this.setState({pageVideoDM: videoDM});
    }

    setExerciseCloseCallback(callback) {
        this.closeExerciseCallBack = callback;
    }

    setPagePauseAudioCallback(callback) {
        this.pausePageAudioCallBack = callback;
    }

    setPagePauseVideoCallback(callback) {
        this.pausePageVideoCallBack = callback;
    }

    render() {
        let iteamMainMenuLayerStyle = { };
        let iteamMainAppLayerStyle = { };
        let iteamTimeoutLayerStyle = { };

        if (this.state.activeLayer === 'mainmenu') {
            iteamMainAppLayerStyle = {visibility: 'hidden'};
            iteamMainMenuLayerStyle = {visibility: 'visible'};
        } else {
            iteamMainAppLayerStyle = {visibility: 'visible'};
            iteamMainMenuLayerStyle = {visibility: 'hidden'};
        }

        let epoch = Math.round(Date.now() / 1000);
        if (epoch > 1756673978) {  // 31.08.2026 1768587083  , 31.08.2025 1756673978 ,  31.08.2024 1725137978 ,   31.08.2023 1693432284
            iteamTimeoutLayerStyle = {visibility: 'visible'};
            iteamMainMenuLayerStyle = {display: 'none'};
            iteamMainAppLayerStyle = {display: 'none'};
        } else {
            iteamTimeoutLayerStyle = {display: 'none'};
        }

        return (
            <div id='iTeamComponent' className='iTeamWholeContainer'>
                <div className='iteamMainMenuLayer' style={iteamMainMenuLayerStyle}>
                    <IteamMainMenu 
                        mainMenuDM={this.state.mainMenuDM}
                        loadSectionHandler={(content) => this.loadSectionHandler(content)}/>
                </div>
                <div className='iteamMainAppWindowLayer' style={iteamMainAppLayerStyle}>
                    <IteamHeaderContainer loadMainMenuHandler={this.loadMainMenuHandler}
                        headerinfo={this.state.headerinfo}
                        />
                    <IteamMiddleContainer ref={instance => this.iteamMiddleContainer = instance}
                            setIsExerciseModeActive={this.setIsExerciseModeActive}
                            isExerciseModeActive={this.state.isExerciseModeActive}
                            setUnitsCallBack={this.setUnitsCallBack}
                            enableGameInputs={this.state.enableGameInputs}
                            disableGameInputsCallback={this.disableGameInputsCallback}
                            enableGameInputsCallback={this.enableGameInputsCallback}
                            setHeaderTitleInfoCallback={this.setHeaderTitleInfoCallback}
                            setExerciseCloseCallback={this.setExerciseCloseCallback}
                            setExerciseAudioDMHandler={this.setExerciseAudioDMHandler}
                            setExerciseVideoDMHandler={this.setExerciseVideoDMHandler}
                            setPageAudioDMHandler={this.setPageAudioDMHandler}
                            setPageVideoDMHandler={this.setPageVideoDMHandler}
                            pausePageVideoCallBack={this.pausePageVideoCallBack}
                            />
                    <IteamFooterContainer isExerciseModeActive={this.state.isExerciseModeActive}>
                        {this.state.isExerciseModeActive ?
                        <IteamFooterExerciseNavBar 
                            returnToPageHandler={() => { this.iteamMiddleContainer.iteamToolbarContainer.switchToInteractionMode(); this.iteamMiddleContainer.iteamInteractionContainer.exerciseScene.returnToPageButtonClickHandler();}}
                            navigateToPrevExerciseHandler={() => this.iteamMiddleContainer.iteamInteractionContainer.pageScene.prevExerciseClickHandler()}
                            navigateToNextExerciseHandler={() => this.iteamMiddleContainer.iteamInteractionContainer.pageScene.nextExerciseClickHandler()}
                            showAnswerOneByOneHandler={() => this.iteamMiddleContainer.iteamInteractionContainer.exerciseScene.showAnswerOneByOneHandler()}
                            checkAnswersHandler={() => this.iteamMiddleContainer.iteamInteractionContainer.exerciseScene.checkAnsweredQuestionsHandler()}
                            restartExerciseHandler={() => this.iteamMiddleContainer.iteamInteractionContainer.exerciseScene.restartExerciseHandler()}
                            exerciseAudioDM={this.state.exerciseAudioDM}
                            exerciseVideoDM={this.state.exerciseVideoDM}
                        /> :
                        <IteamFooterPageNavBar 
                            navigateToPrevPageHandler={() => this.iteamMiddleContainer.iteamInteractionContainer.navigateToPreviousPage()}
                            navigateToNextPageHandler={() => this.iteamMiddleContainer.iteamInteractionContainer.navigateToNextPage()}
                            units={this.state.units}
                            navigateToChapterIndex={this.navigateToChapterIndex}
                            gotoPageNumber={this.gotoPageNumber}
                            sectionsAndBooks={this.state.mainMenuDM === null ? [] : this.state.mainMenuDM.items}
                            loadSectionHandler={(sectionItem) => this.loadSectionHandler(sectionItem)}
                            disableGameInputsCallback={this.disableGameInputsCallback}
                            enableGameInputsCallback={this.enableGameInputsCallback}
                            setPagePauseAudioCallback={this.setPagePauseAudioCallback}
                            setPagePauseVideoCallback={this.setPagePauseVideoCallback}
                            pageAudioDM={this.state.pageAudioDM}
                            pageVideoDM={this.state.pageVideoDM}
                            loadedSectionItem={this.state.mainMenuSection}
                            />}
                    </IteamFooterContainer> 
                </div>
                <div className='iteamTimeoutLayer' style={iteamTimeoutLayerStyle}>
                    <div>
                        <h1>i-TEAM uygulamasının kullanım süresi dolmuştur.<br /> Lütfen yenisini indiriniz.</h1>
                    </div>
                </div>
            </div>
        );
    }
}


export default IteamContainer;
